import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaHtml5, FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';

function CustomerOrderedItems() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);

    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState();
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);

    const [tripDate, setTripDate] = useState('');
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [saleOrderId, setSaleOrderId] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedCustomerData, setSelectedCustomerData] = useState(null);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };


    const [filteredData, setFilteredData] = useState([]);
    const [orderdate, setOrderdate] = useState("");
    const [OrderDateRange, setOrderDateRange] = useState("");

    const [orderTakenby, setOrdertakenby] = useState("");
    const [route, setroute] = useState("");
    const [Executive, setExecutive] = useState("");


    const handleTripChange = async (selectedOption) => {
        const previousTrip = sessionStorage.getItem('selectedTrip');  // Get previous selected trip from session storage

        // If a different trip is selected, save it in sessionStorage and refresh the page
        if (previousTrip && JSON.parse(previousTrip).value !== selectedOption.value) {
            sessionStorage.setItem('selectedTrip', JSON.stringify(selectedOption));  // Store the newly selected trip
            window.location.reload();  // Trigger the page refresh for the new trip
            return;  // Prevent further execution after reload
        }

        // If it's the first trip or the same trip is selected again, show the data without a refresh
        setSelectedTrip(selectedOption);  // Store the selected trip
        setFilteredData([]);  // Clear previous data
        setLoading(true);

        try {
            // Fetch the data for the selected trip
            const response = await fetchData('OrderSheetAPI', `/${companyId}/${selectedOption.value}`, token);

            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                if (dataArray.length > 0) {
                    setFilteredData(dataArray);
                    setOrderdate(dataArray[0].orderDate);  // Set order date
                    setOrdertakenby(dataArray[0].orderTakenby);  // Set who took the order
                    setroute(dataArray[0].routeName);  // Set the route
                    setExecutive(dataArray[0].Executive);
                    setOrderDateRange(dataArray[0].OrderDateRange)
                    setTripDate(dataArray[0].tripDate)

                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
            // }
        } finally {
            setLoading(false);
        }
    };

    // On component load, restore selected trip if available
    useEffect(() => {
        const savedTrip = sessionStorage.getItem('selectedTrip');
        if (savedTrip) {
            const parsedTrip = JSON.parse(savedTrip);
            setSelectedTrip(parsedTrip);  // Restore the selected trip
            handleTripChange(parsedTrip);  // Automatically handle the trip without refresh
        }
    }, []);


    // On component load, check if a trip was saved in sessionStorage and restore it
    useEffect(() => {
        const savedTrip = sessionStorage.getItem('selectedTrip');
        if (savedTrip) {
            const parsedTrip = JSON.parse(savedTrip);
            setSelectedTrip(parsedTrip);
            handleTripChange(parsedTrip);  // Trigger the trip change with the saved trip
        }
    }, []);


    const [routeFilteredData, setRouteFilteredData] = useState([]);

    function moveGrandTotalToEnd(routeFilteredData) {
        let grandTotalRow;
        let filteredData = routeFilteredData.filter((item) => {
            if (item.ordertype === 'Grand Total') {
                grandTotalRow = item;
                return false;
            }
            return true;
        });

        if (grandTotalRow) {
            filteredData.push(grandTotalRow);
        }

        return filteredData;
    }

    // Use the function in your rendering logic
    let sortedData = moveGrandTotalToEnd(routeFilteredData);

    const handleHistoryClick = async (saleorderid) => {
        try {
            const response = await fetchData('VehicleApi', `/${companyId}/${saleorderid}`, token);
            if (response.responseCode === '1111') {
                setSelectedCustomerData(response.response_data);

                setShowModal(true);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };
    //search
    const SearchfilteredData = filteredData.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');

        // Add report title
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 16px;">Customer Ordered Items Report</h3>');

        // Add the first row for Route, Order Taken by, and Order Date
        printWindow.document.write('<div style="font-size: 16px;">');
        printWindow.document.write(`<strong>Route:</strong> ${filteredData[0]?.routeName || ''} | `);
        printWindow.document.write(`<strong>Order Taken by:</strong> ${filteredData[0]?.orderTakenby || ''} | `);
        printWindow.document.write(`<strong>Order Date:</strong> ${filteredData[0]?.orderDate ? new Date(filteredData[0].orderDate).toLocaleDateString('en-GB') : ''}`);
        printWindow.document.write(`<strong>SalesMan:</strong> ${filteredData[0]?.Executive || ''} | `);
        printWindow.document.write(`<strong>Date From:</strong> ${filteredData[0]?.OrderDateRange || ''} | `);
        printWindow.document.write(`<strong>Trip Date:</strong> ${filteredData[0]?.tripDate ? new Date(filteredData[0].tripDate).toLocaleDateString('en-GB') : ''}`);
        printWindow.document.write('</div><br>'); // Ensure some space before the table

        // Add table
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;"></th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Seq.No.</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Customer Name</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Contact Number</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Opening Balance</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Last Sale Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Payment Mode</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Customer Remarks</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Item</th>');


        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Quantity(Psc)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Bundle</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Pieces</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Total Quantity(kg)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Bill Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Total Amt</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 16px; font-weight: bold;">Sale Remarks</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');

        printWindow.document.write('<tbody>');

        let previousCustomerName = null;
        let previousSequenceNo = null;
        let previousContactNumber = null;
        let previousCustomerRemarks = null;

        filteredData.forEach((rowData, index) => {
            printWindow.document.write('<tr>');
            if (rowData.OrderTypeHeading) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.OrderTypeHeading}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${index + 1}</td>`);

            const routeSeqNo = rowData.SequenceNo === previousSequenceNo ? '' : rowData.SequenceNo;
            if (routeSeqNo) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${routeSeqNo}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            //printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${routeSeqNo}</td>`);

            const customerName = rowData.CustomerName === previousCustomerName ? '' : rowData.CustomerName;
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${customerName}</td>`);
            const ContactNumber = rowData.ContactNumber === previousContactNumber ? '' : rowData.ContactNumber;
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${ContactNumber}</td>`);
            if (rowData.oldbalance) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.oldbalance}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.lastsaledate ? new Date(rowData.lastsaledate).toLocaleDateString('en-GB') : ''}</td>`);

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${rowData.PaymentMode || ''}</td>`);
            const CustomerRemarks = rowData.CustomerRemarks === previousCustomerRemarks ? '' : rowData.CustomerRemarks;
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${CustomerRemarks}</td>`);
            if (rowData.item) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.item}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }

            if (rowData.quantity) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.quantity}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            if (rowData.bundle) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.bundle}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            if (rowData.pieces) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.pieces}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            if (rowData.totalquantity) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.totalquantity}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }

            if (rowData.totalAmount) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.totalAmount.toFixed(2)}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }



            if (rowData.PendingTotal) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: right">${rowData.PendingTotal.toFixed(2)}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;text-align: center">${rowData.Remarks || ''}</td>`);

            printWindow.document.write('</tr>');

            previousCustomerName = rowData.CustomerName;
            previousSequenceNo = rowData.SequenceNo;
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };

    const handleExportExcel = () => {
        if (!Array.isArray(processedData) || processedData.length === 0) {
            console.error("No data available for export.");
            return;
        }

        let displayedCustomers = new Set();
        let customerOldBalance = 0;

        // Transform data into a flat structure matching table
        const excelData = processedData
            .sort((a, b) => (a.SequenceNo || 0) - (b.SequenceNo || 0))
            .map((rowData, index, sortedData) => {
                const isFirstRow = index === 0;
                const previousRow = sortedData[index - 1] || {};
                const isNewCustomer = isFirstRow || rowData.CustomerName !== previousRow.CustomerName;

                // Set Old Balance for the first occurrence of the customer
                if (isNewCustomer) {
                    customerOldBalance = rowData.oldbalance || 0;
                }

                const showSequenceNo = isFirstRow || rowData.SequenceNo !== previousRow.SequenceNo;
                const showCustomerName = isNewCustomer;
                const showContactNumber = isNewCustomer;

                // Display Op Bal only once per customer
                const showOldBalance = isNewCustomer && !displayedCustomers.has(rowData.CustomerName);
                if (isNewCustomer) {
                    displayedCustomers.add(rowData.CustomerName);
                }

                const isHighlightedRow = rowData.OrderTypeHeading === "TOTAL";

                return {
                    "": rowData.OrderTypeHeading,
                    "SL No": index + 1,
                    "SeqNo": showSequenceNo ? rowData.SequenceNo || "" : "",
                    "Name": showCustomerName ? rowData.CustomerName || "" : "",
                    "Ph No": showContactNumber ? rowData.ContactNumber || "" : "",
                    "Op Bal": showOldBalance || isHighlightedRow
                        ? customerOldBalance
                            ? customerOldBalance.toFixed(2)
                            : ""
                        : "",
                    "Last Sale": rowData.lastsaledate
                        ? new Date(rowData.lastsaledate).toLocaleDateString("en-GB")
                        : "",
                    "Pay Mode": rowData.PaymentMode || "",
                    "Remark": rowData.CustomerRemarks || "",
                    "Item": rowData.item || "",
                    "Quantity": rowData.quantity || "",
                    "Bundle": rowData.bundle || "",
                    "Pieces": rowData.pieces || "",
                    "Total Qty(kg)": rowData.totalquantity || "",
                    "Bill Amt": rowData.totalAmount?.toFixed(2) || "",
                    "Total Amt": isHighlightedRow
                        ? ((rowData.PendingTotal || 0) + customerOldBalance).toFixed(2)
                        : rowData.PendingTotal?.toFixed(2) || "",
                    "Sale Remarks": rowData.saleremarks || "",
                };
            });

        // Convert JSON to Worksheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Create Workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");

        // Export to Excel File
        XLSX.writeFile(workbook, "Sales_Report.xlsx");
    };

    const handleRefreshClick = () => {
        window.location.reload();
    };

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(100); // Rows per page


    const [columnOrder, setColumnOrder] = useState([
        '',
        'SL No',
        'SeqNo',
        'Name',
        'Ph No',
        'Op Bal',
        'Last Sale',
        'Pay Mode',
        'Remarks',
        'Item',
        'Qty(Psc)',
        'Bundle',
        'Pieces',
        'Total Qty(kgs)',
        'Bill Amt',
        'Total Amt',
        'Sale Remarks'
    ]);

    const processedData = SearchfilteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '98%', marginTop: '10px' }}>
            <h6
                className="uppercase tracking-wide text-black flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>ORDERD SHEET </h6>
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div>
                        <CircularProgress style={{ color: 'white' }} />
                        <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                    </div>
                </div>
            )}
            <div className="flex mb-2" style={{ marginTop: '-20px', marginLeft: '15%' }}>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1 }}>
                    Route: <strong style={{ color: 'darkblue' }}>{route}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Order Taken By: <strong style={{ color: 'darkmagenta' }}>{orderTakenby}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Order  Date: <strong style={{ color: 'darkred' }}>{orderdate && new Date(orderdate).toLocaleDateString('en-GB')}</strong>
                </h5>

                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    SalesMan : <strong style={{ color: 'darkmagenta' }}>{Executive}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Date From: <strong style={{ color: 'darkred' }}>{OrderDateRange}</strong>
                </h5>

                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Date of Supply : <strong style={{ color: 'darkmagenta' }}>{tripDate && new Date(tripDate).toLocaleDateString('en-GB')}</strong>

                </h5>
            </div>
            <div className="flex justify-end" style={{ width: '100%', marginTop: '-10px' }}>
                <div className="flex items-center" style={{ gap: '10px' }}>
                    <div style={{ marginRight: '10px' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '300px' : '200px',
                                height: '40px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>


                    <div className="flex flex-col space-y-1" style={{ width: '300px' }} >
                        <Select
                            value={selectedTrip}
                            onChange={handleTripChange}
                            options={tripOptions}
                            placeholder="Select Trip"
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>

                    <div className="flex gap-2">

                         <Button
                            style={{
                                backgroundColor: '#C9E9D2',
                                color: 'black',
                                height: '36px',
                                marginTop: '-10px',
                                marginLeft: '5px'

                            }}
                            onClick={handleRefreshClick}
                            className="linkcolor"
                        >
                            <span>Refresh</span>
                        </Button>
                        <Button
                            style={{
                                backgroundColor: '#F8E8EE',
                                color: 'black',
                                height: '36px',
                                marginTop: '-10px',
                                marginLeft: '5px'

                            }}
                            onClick={handleExportExcel}
                            className="linkcolor"
                        >
                            <span>Excel</span>
                        </Button>
                        <Button
                            style={{
                                backgroundColor: '#E8F3D6',
                                color: 'black',
                                height: '36px',
                                marginTop: '-10px',
                                marginLeft: '5px'

                            }}
                            onClick={handlePrint}
                            className="linkcolor"
                        >
                            <span>Print</span>
                        </Button>
                       
                    </div>
                </div>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '0.10%' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'whitesmoke', width: '2500px' }}>
                            <TableRow>
                                {columnOrder.map((col, index) => (
                                    <TableCell
                                        key={index}
                                        style={{
                                            padding: '4px',
                                            cursor: 'move',
                                            color: '#B06161',
                                            fontWeight: 'bold',
                                            fontSize: '12px',
                                            textTransform: 'uppercase',
                                        }}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragOver={handleDragOver}
                                        onDrop={(e) => handleDrop(e, index)}
                                    >
                                        {col}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(processedData) && processedData.length > 0 ? (
                                (() => {
                                    let displayedCustomers = new Set(); // Track displayed customers for Op Bal
                                    let customerOldBalance = 0; // Declare it before using

                                    return [...processedData]
                                        .sort((a, b) => (a.SequenceNo || 0) - (b.SequenceNo || 0))
                                        .map((rowData, index, sortedData) => {
                                            const isFirstRow = index === 0;
                                            const previousRow = sortedData[index - 1] || {};
                                            const isNewCustomer = isFirstRow || rowData.CustomerName !== previousRow.CustomerName;

                                            // Set Old Balance only for the first occurrence of the customer
                                            if (isNewCustomer) {
                                                customerOldBalance = rowData.oldbalance || 0;
                                            }

                                            const showSequenceNo = isFirstRow || rowData.SequenceNo !== previousRow.SequenceNo;
                                            const showCustomerName = isNewCustomer;
                                            const showContactNumber = isNewCustomer;

                                            // Display Op Bal only once per customer
                                            const showOldBalance = isNewCustomer && !displayedCustomers.has(rowData.CustomerName);
                                            if (isNewCustomer) {
                                                displayedCustomers.add(rowData.CustomerName);
                                            }

                                            const isHighlightedRow = rowData.OrderTypeHeading === 'TOTAL';

                                            const rowValues = {
                                                '': rowData.OrderTypeHeading,
                                                'SL No': index + 1,
                                                'SeqNo': showSequenceNo ? rowData.SequenceNo || '' : '',
                                                'Name': showCustomerName ? rowData.CustomerName || '' : '',
                                                'Ph No': showContactNumber ? rowData.ContactNumber || '' : '',
                                                'Op Bal': showOldBalance || isHighlightedRow
                                                    ? (customerOldBalance ? customerOldBalance.toFixed(2) : '')
                                                    : '',
                                                'Last Sale': rowData.lastsaledate ? new Date(rowData.lastsaledate).toLocaleDateString('en-GB') : '',
                                                'Pay Mode': rowData.PaymentMode || '',
                                                'Remark': rowData.CustomerRemarks || '',
                                                'Item': rowData.item || '',
                                                'Quantity': rowData.quantity || '',
                                                'Bundle': rowData.bundle || '',
                                                'Pieces': rowData.pieces || '',
                                                'Total Qty(kg)': rowData.totalquantity || '',
                                                'Bill Amt': rowData.totalAmount?.toFixed(2) || '',
                                                'Total Amt': isHighlightedRow
                                                    ? ((rowData.PendingTotal || 0) + customerOldBalance).toFixed(2)
                                                    : rowData.PendingTotal?.toFixed(2) || '',
                                                'Sale Remarks': rowData.saleremarks || '',
                                            };

                                            return (
                                                <React.Fragment key={index}>
                                                    <TableRow
                                                        style={{
                                                            backgroundColor: isHighlightedRow ? '#F5EFE3' : 'inherit',
                                                            borderBottom: '1px solid #ccc',
                                                        }}
                                                    >
                                                        {Object.keys(rowValues).map((key) => (
                                                            <TableCell
                                                                key={key}
                                                                sx={{
                                                                    fontSize: ['Op Bal', 'Quantity', 'Bundle', 'Pieces', 'Total Qty(kg)', 'Bill Amt', 'Total Amt'].includes(key) ? '13px' : '11px',
                                                                    padding: '2px',
                                                                    textAlign: ['Op Bal', 'Quantity', 'Bundle', 'Pieces', 'Total Qty(kg)', 'Bill Amt', 'Total Amt'].includes(key) ? 'right' : 'left',
                                                                    width: '40px',
                                                                    border: '1px solid #ccc',
                                                                    fontWeight: ['Op Bal', 'Quantity', 'Bundle', 'Pieces', 'Total Qty(kg)', 'Bill Amt', 'Total Amt'].includes(key) ? 'Bolder' : 'normal',
                                                                }}
                                                            >
                                                                {rowValues[key]}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </React.Fragment>
                                            );
                                        });
                                })()
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={12} sx={{ textAlign: 'center' }}>
                                        No data available.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>


                        {/* Render Grand Total in Footer */}
                        <TableFooter style={{ padding: '5px' }}>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[15, 25, 50, 100, 250, 350, 500]}
                                    count={SearchfilteredData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </TableContainer>
            </div>

            <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                <div className="fixed inset-0 flex items-start justify-center z-10 ">
                    <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                        <div className="flex justify-end mt-2">
                            <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                <Tooltip title="Close">
                                    <FaTimes />
                                </Tooltip>
                            </button>
                        </div>
                        <h4 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'teal', fontWeight: 'bolder' }}>Ordered Items</h4>
                        <div className="used-items-container">
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Sl.No</th>
                                            <th>Name</th>
                                            <th>BagWeight</th>
                                            <th>Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedCustomerData && selectedCustomerData.map((item, index) => (
                                            <tr key={index}>
                                                <td className="px-4 py-2 border-r">{index + 1}</td>
                                                <td className="px-4 py-2 border-r">{item.item}</td>
                                                <td className="px-4 py-2 border-r">{item.weightage}</td>
                                                <td className="px-4 py-2 border-r">{item.quantity}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </Modal>
        </div >
    );
}

export default CustomerOrderedItems;

